import Vue from "vue";
// need npm 'feathers-icon'
import VueFeather from "vue-feather";

Vue.use(VueFeather);
